import { GRAY_5 } from '~const/colors.const';

export const svgDefaultProps = {
	color: GRAY_5,
	size: 20,
};
